import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-okr-guide',
    templateUrl: './okr-guide.component.html',
    styleUrls: ['./okr-guide.component.css']
})
export class OkrGuideComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
